module.exports = __webpack_public_path__ + "images/42e6bd3d2eaea643373810078422dda9aadd08ae0bbb3681c8ddbae0fe51dab1.svg";